// extracted by mini-css-extract-plugin
export default {"header":"header_header__WwXS-","appBar":"header_appBar__A31dK"};